const password = {
    unsupported_encryption_method: 'Il metodo di crittografia {{name}} non è supportato.',
    pepper_not_found: 'Pepper password non trovato. Per favore controlla le tue env di core.',
};
export default password;
